import { gql, useQuery } from '@apollo/client'
import { Card } from '@tecsinapse/cortex-react'
import React from 'react'

export const linkDownloadByArquivoQueryGql = gql`
  query LinkDownloadByArquivoQuery($idArquivo: ID!) {
    linkDownloadByArquivo(idArquivo: $idArquivo)
  }
`

export const AnuncioCard = ({
  titulo,
  link,
  linkTarget = '_blank',
  idArquivo
}: any) => {
  const { data } = useQuery(linkDownloadByArquivoQueryGql, {
    variables: { idArquivo },
    skip: !idArquivo,
    fetchPolicy: 'cache-first'
  })

  const backgroundImage = data?.linkDownloadByArquivo ?? null

  return (
    <a
      href={link}
      target={linkTarget}
      rel='noopener noreferrer'
      className='no-underline'
      title={titulo ?? ''}
    >
      <Card className='px-0 py-0 flex flex-col w-full h-full rounded-mili overflow-hidden'>
        {backgroundImage ? (
          <img
            src={backgroundImage}
            alt={titulo ?? ''}
            className='w-full flex-1 object-cover rounded-t-mili'
          />
        ) : (
          <div className='w-[244px] h-[360px] flex-1 flex items-center justify-center text-base border rounded-t-mili' />
        )}
      </Card>
    </a>
  )
}
